// Analytics Events Config
// This file contains event names for analytics tracking

export const ANALYTICS_EVENT_NAMES = {
  BACK: 'back',
  SAVE: 'save',
  PROCEED: 'proceed',
  BOOST_BACK: 'boost_back',
  // User Events
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  USER_SIGNUP: 'user_signup',
  USER_REGISTER: 'user_register',
  PROFILE_CREATE: 'profile_create',
  PROFILE_UPDATE: 'profile_update',
  PROFILE_VIEW: 'profile_view',
  PROFILE_EDIT: 'profile_edit',
  PROFILE_DELETE: 'profile_delete',
  PROFILE_VERIFY: 'profile_verify',
  FIND_PROPERTY_DASHBOARD: 'find_property_dashboard',
  UNLOCK_PROPERTY: 'unlock_property',
  MESSAGE_OWNER: 'message_owner',
  RE_INITIATE_VERIFICATION: 're_inititate_verification',
  REGENERATE_DESCRIPTION: 'regenerate_description',
  BOOST_VIEW: 'boost_view',
  SETUP_SHOP: 'setup_shop_home',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_BACK: 'payment_back',
  START_FREE_TRIAL: 'start_free_trial',
  STARTED_FREE_TRIAL: 'started_free_trial',
  FREE_TRIAL: 'free_trial_initiated',
  I_AM_NOT_AN_AGENT: 'I am not an Agent',

  // Property Events
  PROPERTY_ADD: 'property_add',
  ADD_LISTING: 'add_listing',
  PROPERTY_ADD_SUCCESS: 'property_add_success',
  PROPERTY_VIEW: 'property_view',
  PROPERTY_EDIT: 'property_edit',
  PROPERTY_DELETE: 'property_delete',
  PROPERTY_SAVE: 'property_save',
  PROPERTY_UNSAVE: 'property_unsave',
  PROPERTY_SHARE: 'property_share',
  PROPERTY_BOOST: 'property_boost',
  PROPERTY_VERIFY: 'property_verify',
  PROPERTY_DEAL_CLOSURE: 'property_deal_closure',
  PROPERTY_DEAL_CLOSURE_CLOSE: 'property_deal_closure_close',

  // Search Events
  SEARCH_PROPERTY: 'search_property',
  SEARCH_AGENT: 'search_agent',
  SEARCH_LOCATION: 'search_location',
  SEARCH_FILTER: 'search_filter',
  SEARCH_CLEAR: 'search_clear',
  SEARCH_RESULTS: 'search_results',
  ADVANCE_FILTER_APPLY: 'advance_filter_apply',
  ADVANCE_FILTER_CLEAR: 'advance_filter_clear',

  RECOMMENDATION_SEARCH: 'recommendation_search',
  BOOST_SEARCH: 'boost_search',
  BOOST_VIEW_ALL: 'boost_view_all',
  BOOST: 'boost_details',
  ONE_CLICK_MARKETING: 'one_click_marketing',
  VIEW_LEADS: 'view_leads',
  VIEW_PROFILE: 'view_profile_recommendation',

  // Navigation Events
  NAVIGATE_HOME: 'navigate_home',
  NAVIGATE_DASHBOARD: 'navigate_dashboard',
  NAVIGATE_ADD_PROPERTY: 'navigate_add_property',
  NAVIGATE_PROFILE: 'navigate_profile',
  NAVIGATE_MESSAGES: 'navigate_messages',
  NAVIGATE_REQUIREMENTS: 'navigate_requirements',
  NAVIGATE_FIND_AGENTS: 'navigate_find_agents',

  //agent profile create
  AGENT_PROFILE_CREATE: 'agent_profile_create',
  AGENT_PROFILE_UPDATE: 'agent_profile_update',
  AGENT_PHOTO_UPLOAD: 'agent_photo_upload',

  // Messaging Events
  MESSAGE_SEND: 'message_send',
  MESSAGE_RECEIVE: 'message_receive',
  MESSAGE_READ: 'message_read',
  CHAT_START: 'chat_start',
  CHAT_END: 'chat_end',

  // Upload Events
  FILE_UPLOAD: 'file_upload',
  FILE_DELETE: 'file_delete',
  IMAGE_UPLOAD: 'image_upload',
  DOCUMENT_UPLOAD: 'document_upload',

  // Boost Events
  BOOST_PURCHASE: 'boost_purchase',
  BOOST_ACTIVATE: 'boost_activate',
  BOOST_DEACTIVATE: 'boost_deactivate',
  BOOST_UPGRADE: 'boost_upgrade',

  // Materials Events
  MATERIAL_GENERATE: 'material_generate',
  MATERIAL_DOWNLOAD: 'material_download',
  MATERIAL_SHARE: 'material_share',
  FLYER_CREATE: 'flyer_create',
  BROCHURE_CREATE: 'brochure_create',

  // Organization Events
  TEAM_ADD: 'team_add',
  TEAM_REMOVE: 'team_remove',
  TEAM_INVITE: 'team_invite',
  ROLE_CHANGE: 'role_change',

  // Notification Events
  NOTIFICATION_ENABLE: 'notification_enable',
  NOTIFICATION_DISABLE: 'notification_disable',
  NOTIFICATION_READ: 'notification_read',

  // Sharing Events
  SHARE_LINK: 'share_link',
  SHARE_SOCIAL: 'share_social',
  SHARE_EMAIL: 'share_email',

  // Error Events
  ERROR_VALIDATION: 'error_validation',
  ERROR_NETWORK: 'error_network',
  ERROR_SERVER: 'error_server',
  ERROR_TIMEOUT: 'error_timeout',
};
